export enum MatchWeather {
    Cloudy = 'Cloudy',
    Rainy = 'Rainy',
    Sunny = 'Sunny',
  }
  
  export const matchWeather = Object.keys(MatchWeather);